import React, { useContext, useEffect, useState } from "react";
import useFetch from "../../Hooks/useFetch";
import { useNavigate } from "react-router-dom";
import { userContext } from "../../Contexts/userContext";
import Members from "../../Template/Home/Members/Members";
import { membersURL } from "../../Hooks/URL";
import useDelete from "../../Hooks/useDelete";
import { Fetch } from "../../Hooks/Fetch";
import useFetchWhen from "../../Hooks/useFetchWhen";

function MembersPage() {
  const { contextData, setContextData } = useContext(userContext);
  const navigate = useNavigate();

  const [searchData, setSearchData] = useState("");
  const [search, setSearch] = useState("");
  const [Filter, setFilter] = useState("");

  const [members, setMembers] = useState([]);
  const [memberDeleted, setMemberDeleted] = useState("");
  const [deletedSuccess, setDeletedSuccess] = useState(false);
  const { data, loading, error } = useFetch(membersURL);
  const {
    data: membersData,
    loading: membersLoading,
    error: membersError,
  } = useFetchWhen(membersURL, deletedSuccess, setDeletedSuccess);

  const { state: deleteRes } = useDelete(
    `${membersURL}/${memberDeleted}`,
    memberDeleted,
    null,
    null,
    null,
    "",
    setMemberDeleted
  );

  useEffect(() => {
    if (deleteRes?.data?.status == "success") setDeletedSuccess(true);
  }, [deleteRes]);

  useEffect(() => {
    if (!loading && !error && data) {
      setMembers(data.data);
    }
  }, [data, loading, error]);

  useEffect(() => {
    if (!membersLoading && !membersError && membersData) {
      setMembers(membersData.data);
    }
  }, [membersData, membersLoading, membersError]);

  useEffect(() => {
    setContextData({ ...contextData, page: "members", data: "" });
  }, []);

  return (
    <Members
      searchData={searchData}
      search={search}
      setSearchData={setSearchData}
      setSearch={setSearch}
      members={members}
      setMembers={setMembers}
      navigate={navigate}
      loading={memberDeleted ? membersLoading : loading}
      setFilter={setFilter}
      setMemberDeleted={setMemberDeleted}
    />
  );
}

export default MembersPage;
